// extracted by mini-css-extract-plugin
export default {"wrapper":"TypingDots_wrapper__eXd1c","dot1":"TypingDots_dot1__UYbe9","dot2":"TypingDots_dot2__dtssK","dot3":"TypingDots_dot3__E6mXC"};